// 变体筛选隐藏功能
// function updateMediaGallery(textArray) {

//     let thumbnailAltArr = [];

//     $(".productView-thumbnail-wrapper:not('.is-hidden-desktop') .productView-thumbnail").each(function() {
//         let thumbnailAlt = $(this).attr("thumbnail-alt");
//         let thumbnailAltArray = thumbnailAlt.split(',').map(item => item.trim());

//         if (thumbnailAltArray.includes("all") || thumbnailAltArray.every(item => textArray.includes(item))) {
//             // 获取this的id 用slider的方式来隐藏
//             thumbnailAltArr.push($(this).attr('data-media-id'))
//         } 
//     });

//     if (thumbnailAltArr.length) {
//         let parStr = thumbnailAltArr.map(item => `[data-media-id='${item}']`).join(' , ');
//         $(".productView-images-wrapper .slick-slider:not('.mobile')").slick('slickFilter',parStr );
//     }else{
//         $(".productView-images-wrapper .slick-slider:not('.mobile')").slick('slickUnfilter')
//     }


// }
// $(document).ready(function () {
//     let ogThumbnailIndex = {};

//     // 初始化 ogThumbnailIndex
//     setTimeout(function () {
//         // 触发默认变体切换
//         const defaultVariant = $(".productView-variants .product-form__radio")[0];
//         $(defaultVariant).trigger("change");

//         // 记录初始的 data-slick-index 和 data-media-id 的映射
//         $(".productView-thumbnail-wrapper .slick-slide").each(function () {
//             const slickIndex = $(this).data("slick-index");
//             const mediaId = $(this).data("media-id");
//             if (slickIndex !== undefined && mediaId) {
//                 ogThumbnailIndex[slickIndex] = mediaId;
//             }
//         });

//     }, 3000);

//     // 监听主图切换事件
//     $('.productView-image-wrapper').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        
//         triggerBeforeChange(currentSlide, nextSlide);
//     });

//     // 监听变体切换事件
//     $(".productView-variants .product-form__radio").on("change", function () {
//         // 移除所有过滤条件
//         $(".productView-images-wrapper .slick-slider:not('.mobile')").slick('slickUnfilter');

//         // 获取当前选中的变体选项
//         const labels = $(".productView-options .product-form__radio:not('.mobile'):checked");
//         const textArray = labels.map(function () {
//             return $(this).attr("value").toLowerCase();
//         }).get();

//         // 根据选项更新画廊内容
//         updateMediaGallery(textArray);

//         // 延迟刷新 slick 状态，确保切换逻辑正确
//         setTimeout(function () {
//             $(".productView-images-wrapper .slick-slider").slick('refresh');
//         }, 1000);
//     });

//     // 封装 beforeChange 的逻辑为独立函数
//     function triggerBeforeChange(currentSlide, nextSlide) {

//         // const targetMediaId = ogThumbnailIndex[nextSlide]; // 从映射中找到目标 media ID

//         // if (targetMediaId) {
//         //     // 查找新缩略图索引
//         //     const curIndex = $(".productView-thumbnail-wrapper .slick-slide").filter(function () {
//         //         return $(this).data("media-id") === targetMediaId;
//         //     }).data("slick-index");
//         //     console.log(`curIndex`,curIndex);

//         //     if (curIndex !== undefined) {
//         //         // 同步缩略图和主图索引
//         //         $(".productView-thumbnail-wrapper .slick-slider:not('.mobile')").slick('slickGoTo', curIndex);
//         //         $(".productView-image-wrapper .slick-slider:not('.mobile')").slick('slickGoTo', curIndex);
//         //     }
//         // }
//     }

//     // 更新画廊的逻辑
//     function updateMediaGallery(textArray) {
//         let thumbnailAltArr = [];

//         $(".productView-thumbnail-wrapper:not('.is-hidden-desktop') .productView-thumbnail").each(function () {
//             const thumbnailAlt = $(this).attr("thumbnail-alt");
//             const thumbnailAltArray = thumbnailAlt.split(',').map(item => item.trim());

//             if (thumbnailAltArray.includes("all") || thumbnailAltArray.every(item => textArray.includes(item))) {
//                 thumbnailAltArr.push($(this).attr('data-media-id'));
//             }
//         });

//         const slickSlider = $(".productView-images-wrapper .slick-slider:not('.mobile')");

//         // 移除过滤后重新筛选
//         slickSlider.slick('slickUnfilter');

//         if (thumbnailAltArr.length) {
//             const parStr = thumbnailAltArr.map(item => `[data-media-id='${item}']`).join(', ');
//             slickSlider.slick('slickFilter', parStr);
//         }
//     }
// });

// 变体筛选隐藏功能END

// 覆盖模板原有的variant_image_group方法
window.variant_image_group = false;


// 详情页下拉js
$(document).ready(function() {
    $('.switch_tabs .item-tab').on('click', function() {
        
        const tabKey = $(this).data('tab');
        const $tabContent = $(`.switch_tabs .tw-details[data-tab="${tabKey}"]`);
        if ($tabContent.is(':visible')) {
            $tabContent.slideUp();  
        } else {
            $tabContent.slideDown();  
        }
        $(this).find('svg').toggleClass("tw-rotate-180");
    });
    
});
// 详情页下拉js END
      
